import * as React from 'react';
import { IconProps } from '../types';

const IcPause = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='15' height='20' viewBox='0 0 15 20' fill='none' {...props}>
    <path
      d='M4.08211 2.6169C4.08211 1.23619 3.39909 0 2.01838 0C0.63767 0 -1.26416e-05 1.11929 -1.26416e-05 2.5V17.5C-1.26416e-05 18.8807 0.63767 20 2.01838 20C3.39909 20 4.08211 18.9976 4.08211 17.6169V2.6169Z'
      fill={props?.fill || '#1D2129'}
    />
    <path
      d='M14.1005 2.5C14.1005 1.11929 13.3991 0 12.0184 0C10.6377 0 9.97919 1.11929 9.97919 2.5V17.5C9.97919 18.8807 10.6377 20 12.0184 20C13.3991 20 14.1005 18.8807 14.1005 17.5V2.5Z'
      fill={props?.fill || '#1D2129'}
    />
  </svg>
);

export default IcPause;
